import { createSelector } from '@reduxjs/toolkit';

import { selectAppConfig } from '../config/selectAppConfig';
import { selectUserProfile } from './selectUserProfile';

export const selectDateFormat = createSelector(
  [selectAppConfig, selectUserProfile],
  ({ systemDateFormat }, { initialized, dateFormat }) => (initialized ? dateFormat : systemDateFormat),
);
